module.exports = __webpack_public_path__ + "static/media/bg6.e76de24b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg6.jpg
// module id = 166
// module chunks = 0